
import { Component, Vue } from 'vue-property-decorator';
import { NotifyHelpers } from '@/ts/helpers/NotifyHelpers';

@Component
export default class NotifyMethods extends Vue {
    public notify(
        translationKey: string,
        type: string,
        attribute: string = '',
        timeout: number = 3000,
        position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'top' | 'bottom' | 'left' | 'right' | 'center' = 'bottom-right',
    ): void {
        const langKey = this.$store.getters['Localization/getLocalizationKey'];
        const message = NotifyHelpers.translateMessage(translationKey, langKey, attribute);

        this.$q.notify({
            message,
            type,
            position,
            timeout,
        });
    }
}
